<template>
	<div class="row">
		<div class="col-12">
			<h4>Selecione a Fila</h4>
			<div class="row">
				<div class="col-5">
					<h6 class="text-center">Filas disponíveis</h6>
					<input id="input-search" name="input-search" @click="searchQueue" type="input"
						class="form-control form-control-sm" placeholder="Pesquisar fila" />
					<select id="avaiableQueuesOnly" name="avaiableQueuesOnly[]" class="custom-select" multiple
						style="width: 100%; height: 85%">
					</select>
				</div>

				<div class="col-2">
					<h6 class="text-center">Ações</h6>
					<div class="row">
						<div class="col-12">
							<button type="button" class="btn btn-block btn-primary"
								@click="transferQueuesOnly('right', 'all')"><i
									class="fas fa-angle-double-right fa-fw"></i></button>
						</div>
						<div class="col-12">
							<button type="button" class="btn btn-block btn-primary"
								@click="transferQueuesOnly('right', 'selected')"><i
									class="fas fa-angle-right fa-fw"></i></button>
						</div>
						<div class="col-12">
							<button type="button" class="btn btn-block btn-primary"
								@click="transferQueuesOnly('left', 'selected')"><i
									class="fas fa-angle-left fa-fw"></i></button>
						</div>
						<div class="col-12">
							<button type="button" class="btn btn-block btn-primary"
								@click="transferQueuesOnly('left', 'all')"><i
									class="fas fa-angle-double-left fa-fw"></i></button>
						</div>
					</div>
				</div>

				<div class="col-5">
					<h6 class="text-center">Filas Selecionadas</h6>
					<select id="selectedQueuesOnly" name="selectedQueues[]" class="custom-select" multiple
						style="width: 100%; height: 100%" required>
					</select>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			groups: [],
			listExtensions: [],
		};
	},
	created() {
		this.getData();
		this.searchQueue();
	},
	methods: {
		searchQueue() {
			$("#input-search").keyup(function () {
				let filterName = $(this).val().toUpperCase();
				$("#avaiableQueuesOnly").find("option").each(function () {
					let elementContent = $(this).text().toUpperCase();
					let matches = elementContent.indexOf(filterName) >= 0;
					$(this).css("display", matches ? "block" : "none");
				});
			});
		},
		transferQueuesOnly(direction, quantity) {
			var self = this;
			const element = $(direction == "right" ? "#avaiableQueuesOnly" : "#selectedQueuesOnly");
			const optionList = () => {
				let visibleElements = [];
				if (quantity != "all") {
					element.find("option:selected").each((index, obj) => {
						if ($(obj).css("display") != "none") {
							visibleElements.push(obj);
						}
					});
					return element.find("option:selected");
				} else {
					element.find("option").each((index, obj) => {
						if ($(obj).css("display") != "none") {
							visibleElements.push(obj);
						}
					});
					return $(visibleElements);
				}
			};

			optionList().prop("selected", true);
			optionList().each(function (i, obj) {
				if (direction == "right") {
					self.groups.forEach((group) => {
						if (group.group == $(obj).val()) {
							group.extensions.forEach((extension) => {
								self.listExtensions.push(extension);
							});
						}
					});
				} else {
					self.groups.forEach((group) => {
						if (group.group == $(obj).val()) {
							self.listExtensions = self.listExtensions.filter(function (x) {
								return group.extensions.indexOf(x) < 0;
							});
						}
					});
				}
			});

			this.populateExtensions();
			const secondElement = $(direction == "right" ? "#selectedQueuesOnly" : "#avaiableQueuesOnly");
			secondElement.append(optionList());
			secondElement.trigger("focus");
		},
		populateExtensions() {
			$('#avaiableExtensions, #selectedExtensions').find(`option`).remove();
			this.listExtensions = this.listExtensions.filter((a, b) => this.listExtensions.indexOf(a) === b)
			this.listExtensions.forEach(extension => {
				const option = `<option value="${extension}">${extension}</option>`
				$('#avaiableExtensions').append(option);
			})
		},
		getData() {
			axios.get(`${window.location.pathname}/listQueues`)
				.then((response) => {
					const groups = response.data;
					this.groups = groups;
					groups.forEach(group => {
						const element = `<option value="${group.filas}">${group.group}</option>`
						$('#avaiableQueuesOnly').append(element);
					})
				})
				.catch((error) => {
					console.error(error);
				})
		}
	}
}
</script>
